import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { LocationService } from '../../../services/location.service';
import { PrdLocationService } from '../../../services/prdLocation.service';
import { ProductionService } from '../../../services/production.service';
import { RouterService } from '../../../services/router.service';
import { SrvLocationService } from '../../../services/SrvLocation.service';
import { SystemInternalService } from '../../../services/systemInternal.service';
import { UserService } from '../../../services/user.service';
import { IGetConfigurationCodeV3 } from '../../Interfaces/iconfig';
import { IOrderId, IPASInProduction } from '../../Interfaces/iproduction';

declare interface Location {
  locationName: string;
  userName: string;
  difference: string;
  differenceMinutes: number;
  percentage: number;
  class: string;
}

@Component({
  selector: 'kds-data',
  templateUrl: './kds.component.html'
})

export class KdsComponent {
  constructor(
    private router: Router,
    private locationService: LocationService,
    private securityParams: ActivatedRoute,
    private productionService: ProductionService,
    private prdLocationService: PrdLocationService,
    private srvLocationService: SrvLocationService,
    private _snackBar: MatSnackBar,
    private routerService: RouterService,
    private systemInternalService: SystemInternalService,
    private userService: UserService
  ) {
    this._timer = setInterval(() => this.loadServiceLocations(), 15000);
    this.SetIntervalProduction() /* this._productionTimer = setInterval(() => this.loadPASInProduction(), 11000)*/
  }

  menuLocations: any[];
  _result: boolean = false;
  locations: Location[];
  menuPas: IPASInProduction[];
  //menuPasIn: IPASInProduction[];
  //menuPasInProduction: IPASInProduction[];
  menuPasDeleted: IPASInProduction[];
  locationId: number;
  centerName: string;
  registryTimeout: number;
  messageLocations: string = "";
  _timer: any;
  _productionTimer: any;
  _buttonPrdToInTimer: any;
  _ClickProductionModeNext: boolean = true;
  _FontSizeTitle: string = "15px";
  _FontSizeSubtitle: string = "13px";
  _FontSizeComment: string = "13px";
  _FontSizeTime: string = "10px";

  _PasInFilter: number = 0;
  _IntervalProductionOn: boolean = true;
  myId: number = 0;
  Iteractions: number = 0;


  async ngOnInit() {
    //var processData = angular.module('library.process_data', ['blockUI']);
    const _Config: IGetConfigurationCodeV3 = {
      code: "KDSFNTSIZE", parentCode: "KDSA"
    }
    this.locationId = parseInt(this.securityParams.snapshot.params.locationid);
    this.userService.GetMyId().subscribe(result => {
      if (result.body.isValid) {
        this.myId = result.body.resultData.id;
      }
    },
      (e) => {
        console.log(e);
      });
    this.systemInternalService.GetConfiguration(_Config).subscribe(result => {
      if (result.body.isValid) {
        if (result.body.resultData.numbervalue >= 15 && result.body.resultData.numbervalue <= 30) {
          this._FontSizeTitle = result.body.resultData.numbervalue.toString().trim() + "px";
          this._FontSizeSubtitle = (result.body.resultData.numbervalue - 2).toString() + "px";
          this._FontSizeComment = (result.body.resultData.numbervalue - 4).toString() + "px";
          this._FontSizeTime = (result.body.resultData.numbervalue - 7).toString() + "px";
        }
      }
    },
      (e) => {
        console.log(e);
      });
    this.prdLocationService.GetProductionDataV2(this.locationId).subscribe(result => {
      if (result.body.isValid) {
        this.centerName = result.body.resultData.name; this.registryTimeout = result.body.resultData.registryTimeout;
      }
      else {
        alert(result.body.error.description);
      }
    },
      (e) => {
        console.log(e);
      });
    this.locations = [];
    this.menuLocations = [];
    this.loadServiceLocations();
    this.loadPASInProduction();
    //
    this.menuPas = [];
    //this.menuPasIn = [];
    //this.menuPasInProduction = [];
    this.menuPasDeleted = [];
    //this.pasIn = [];
    //this.pasInProduction = [];


  }

  ngOnDestroy(): void {
    clearInterval(this._timer);
    this.ClearIntervalProduction();
    //clearTimeout(this._productionTimer);

  }

  SetIntervalProduction() {
    this._IntervalProductionOn = true;
    this._productionTimer = setInterval(() => {
      this.loadPASInProduction();
    }, 15000, 15000);

  }

  ClearIntervalProduction() {
    this._IntervalProductionOn = false;
    //clearTimeout(this._productionTimer);
    if (this._productionTimer) {
      clearInterval(this._productionTimer);
    }
  }

  private async loadServiceLocations() {
    this.srvLocationService.GetServiceLocationsInProduction(this.locationId).subscribe(result => {
      if (result.body.isValid) {
        this.locations = [];
        this.menuLocations = [];
        for (const entry of result.body.resultData) {
          this.addLocations({
            locationName: entry.locationName.substring(0, 20).trim(), userName: entry.userName.substring(0, 20).trim(), difference: entry.difference.substring(0, 20),
            differenceMinutes: entry.differenceMinutes, percentage: entry.percentage, class: entry.function_class, color01: entry.color01, color02: entry.color02
          });
        }
        this.menuLocations = this.locations; //.filter(menuLocation => menuLocation);
        this.messageLocations = "";

      }
      else {
        if (result.body.error.code == 204) {
          this.locations = [];
          this.menuLocations = [];
          this.messageLocations = result.body.error.description;
        }
        else {
          alert(result.body.error.description);
        }
      }
    },
      (e) => {
        console.log(e);
      });
    return this.locations;
  }

  private async loadPASInProduction() {
    if (!this._IntervalProductionOn) 
      return;
    this.productionService.GetPASinProductionV2(this.locationId,0) //.pipe(finalize(() => this.SetIntervalProduction()))
      .subscribe(result => {
        if (result.body.isValid) {
          for (const entry of result.body.resultData) {
            if (entry.children == 0) {
              var _Item = this.menuPas.find(x => x.id == entry.id);
              if (_Item) {
                _Item.updated = true;
                _Item.difference = entry.difference.substring(0, 20);
                _Item.differenceMinutes = entry.differenceMinutes;
                _Item.onTime = entry.onTime; _Item.color01 = entry.color01; _Item.color02 = entry.color02, _Item.color03 = entry.color03;
                _Item.locationName = entry.locationName.substring(0, 20).trim();
                //Updated: 20/Nov/2024
                // 8/march/2025
                if (entry.status != _Item.status && entry.userPrdId != this.myId) { //_StatusOri
                  _Item.status = entry.status;
                  var _Children = result.body.resultData.find(x => x.parentId == entry.id)
                  if (!_Children) {
                    switch (entry.status) {
                      case "R":
                        this.MoveScreenItemToIn(entry.id);
                        break;
                      case "P":
                        this.MoveScreenItemToProduction(entry.id);
                        break;
                      default:
                        this.MoveScreenItemToOut(entry.id);
                        break;
                    }
                  }
                }
              }
              else {
                if ((this.Iteractions == 0 || entry.userPrdId != this.myId)) {
                  switch (entry.status) {
                    case "R":
                      entry.userPrdId = this.myId;
                      this.addPASIn(entry);
                      this.MoveScreenItemToIn(entry.id);
                      break;
                    case "P":
                      entry.userPrdId = this.myId;
                      this.addPASInProduction(entry);
                      this.MoveScreenItemToProduction(entry.id);
                      break;
                    default:
                      this.MoveScreenItemToOut(entry.id);
                  }
                //  if (entry.parentId > 0) {
                //    var _ItemParent = this.menuPas.find(x => x.id == entry.parentId && x.status==entry.status);
                //    if (!_ItemParent) {
                //      var _ItemParent = result.body.resultData.find(x => x.id == entry.parentId );
                //      _ItemParent.onTime = 1;
                //      _ItemParent.userPrdId = this.myId;
                //      switch (entry.status) {
                //        case "R":
                //          this.addPASInContainer(_ItemParent, _ItemParent.difference);
                //          break;
                //        case "P":
                //          this.addPASInProduction(_ItemParent);
                //          break;
                //      }
                //    }
                //  }
                }
              }
            }
            else {
              var _Item = this.menuPas.find(x => x.id == entry.id && x.status==entry.status);
              if (_Item) {
                _Item.difference = entry.difference.substring(0, 20);
                _Item.differenceMinutes = entry.differenceMinutes;
                _Item.onTime = entry.onTime; _Item.color01 = entry.color01; _Item.color02 = entry.color02, _Item.color03 = entry.color03;
                if (entry.userPrdId != null && entry.userPrdId != this.myId) {
                  _Item.status = entry.status;
                  _Item.updated = true;
                }
              }
              else {
                //check children with the same status
                var _Items = result.body.resultData.find(x => x.parentId == entry.id && x.status==entry.status);
                if (_Items != null) {
                  var _Item = result.body.resultData.find(x => x.id == entry.id);
                  _Item.onTime = 1;
                  _Item.userPrdId = this.myId;
                  switch (entry.status) {
                    case "R":
                      this.addPASInContainer(_Item, _Item.difference);
                      break;
                    case "P":
                      this.addPASInProduction(_Item);
                      break;
                  }
                }
              }
            }
          }
          this.Iteractions++;
        }
        else {
          if (result.body.error.code == 204) {
            this.menuPas = [];
          }
          else {
            alert(result.body.error.description);
          }
        }
      },
        (e) => {
          console.log(e);
        });
    return this.locations;
  }

  addLocations(route) {
    this.locations.push(route);
  }

  addPASInContainer(route, difference: string) {
    this.menuPas.push({
      id: route.id, color01: route.color01, color02: route.color02, color03: route.color03, compType: route.compType, difference: difference, // route.difference.substring(0, 20)
      differenceMinutes: route.differenceMinutes, function_class: route.function_class, locationName: route.locationName.substring(0, 20).trim(), onTime: route.onTime,
      parentId: route.parentId, pasNameUm: route.pasNameUm, quantity: route.quantity, requestOrder: route.requestOrder, status: "R", textOptions: route.textOptions,
      userPrdId: route.userPrdId, updated:true, children:route.children,locationProductionId:route.locationProductionId
    });
  }

  addPASInProductionContainer(route) {
    this.menuPas.push({
      id: route.id, color01: route.color01, color02: route.color02, color03: route.color03, compType: route.compType, difference: route.difference.substring(0, 20),
      differenceMinutes: route.differenceMinutes, function_class: route.function_class, locationName: route.locationName.substring(0, 20).trim(), onTime: route.onTime,
      parentId: route.parentId, pasNameUm: route.pasNameUm, quantity: route.quantity, requestOrder: route.requestOrder, status: "P", textOptions: route.textOptions,
      userPrdId: route.userPrdId, updated: true, children: route.children, locationProductionId: route.locationProductionId
    });
  }


  addPASIn(route) {
    var _Item = this.menuPas.find(x => x.id == route.id);
    if (!_Item) {
      route.locationName = route.locationName.substring(0, 20).trim();
      route.difference = route.difference.substring(0, 20);
      route.updated = true;
      route.status = "R"; 
      this.menuPas.push(route);
    }
  }

  addPASInProduction(route) {
    route.locationName = route.locationName.substring(0, 20).trim();
    route.difference =  route.difference.substring(0, 20);
    route.updated = true;
    route.status = "P";
    this.menuPas.push(route);
  }

  filterPasInGroups() {
    try {
      if (this.menuPas.length > 0) {
        return this.menuPas.filter(x => x.parentId == 0  && x.status=="R");
      }
      else {
        return null;

      }
    } catch {
      return null;
    }
  }

  filterPasIn(idparent) {
    return this.menuPas.filter(x => x.parentId == idparent && x.status=="R");
  }

  filterPasPrdGroups() {
    try {
      if (this.menuPas.length > 0) {
        return this.menuPas.filter(x => x.parentId == 0 && x.status=="P");
      }
      else {
        return null;

      }
    } catch {
      return null;
    }
  }

  //return this.menuPasInProduction.filter(x => x.parentId == 0);

  filterPasPrd(idparent) {
    return this.menuPas.filter(x => x.parentId == idparent && x.status=="P");
  }

  //updated: 28/oct/2025 
  MoveScreenItemToIn(Id) {
    var _Item = this.menuPas.find(x => x.id == Id && x.status == "P");
    //check container
    if (_Item && _Item.parentId > 0) {
      var _ItemParent = this.menuPas.find(x => x.id == _Item.parentId && x.status == "R");
      //if ! exists container in In screen
      if (!_ItemParent) {
        var _ItemParent = this.menuPas.find(x => x.id == _Item.parentId && x.status == "P");
        if (_ItemParent) {
          _ItemParent.userPrdId = this.myId;
          _ItemParent.onTime = 1;
          this.addPASInContainer(_ItemParent, "--");
        };
      }
      //drop container in Production screen if only has one child
      var _Children = this.menuPas.filter(x => x.parentId == _Item.parentId && x.status == "P");
      if (_Children.length == 1) {
        this.menuPas = this.menuPas.filter(x => !(x.id == _Item.parentId && x.status == "P"));
      }
    }
    //move item(s) from production to in screen
    var _Items = this.menuPas.filter(x => (x.id == Id || x.parentId == Id) && x.status == "P");
    for (const _Item of _Items) {
      if (_Item.compType > 0) {
        var _Parentfound = this.menuPas.find(x => x.id == _Item.id && x.status == "R");
        if (!_Parentfound) {
          this.addPASInContainer(_Item, _Item.difference);
        }
      }
      else {
        var _ItemId = this.menuPas.find(x => x.id == _Item.id);
        _ItemId.status = "R";  //28/oct/2025 check pending
        //this.menuPas.push(_Item);
      }
    }
    //drop item and its childrens
    this.menuPas = this.menuPas.filter(x => !((x.id == Id || x.parentId == Id) && x.status == "P"));
    return _Items;
  }

  MoveScreenItemToProduction(Id) {
    //click on item with parent
    var _Item = this.menuPas.find(x => x.id == Id && x.status=="R");
    if (_Item && _Item.parentId > 0) {
      var _ItemParent = this.menuPas.find(x => x.id == _Item.parentId && x.status=="P");
      if (!_ItemParent) {
        var _ItemParent = this.menuPas.find(x => x.id == _Item.parentId && x.status=="R");
        if (_ItemParent) {
          _ItemParent.userPrdId = this.myId;
          _ItemParent.onTime = 1;
          this.addPASInProductionContainer(_ItemParent);
        };
      }
      var _Children = this.menuPas.filter(x => x.parentId == _Item.parentId && x.status == "R");
      if (_Children.length == 1) {
        this.menuPas = this.menuPas.filter(x =>! (x.id == _Item.parentId && x.status=="R"));
      }
    }
    //click on item with or without children
    var _Items = this.menuPas.filter(x => (x.id == Id || x.parentId == Id) && x.status=="R");
    for (const _Item of _Items) {
      _Item.difference = "00";
      _Item.differenceMinutes = 0;
      _Item.userPrdId = this.myId;
      _Item.onTime = 1;
      if (_Item.compType > 0) {
        var _Parentfound = this.menuPas.find(x => x.id == _Item.id && x.status=="P");
        if (!_Parentfound) {
          this.addPASInProductionContainer(_Item);
        }
      }
      else {
        var _ItemId = this.menuPas.find(x => x.id == _Item.id);
        _ItemId.status = "P";  //28/oct/2025 check pending
      //  this.menuPasInProduction.push(_Item);
      }
    }
    //drop item and its childrens
    this.menuPas = this.menuPas.filter(x => !((x.id == Id || x.parentId == Id) && x.status=="R"));
    return _Items;
  }

  MoveScreenItemToOut(Id) {
    //drop parent container
    var _Item = this.menuPas.filter(x => x.id == Id && x.status == "P");
    if (_Item.length > 0) {
      if (_Item[0].parentId > 0) {
        var _Items = this.menuPas.filter(x => x.parentId == _Item[0].parentId && x.status=="P");
        if (_Items.length == 1) {
          this.menuPas = this.menuPas.filter(x =>!( x.id==_Item[0].parentId && x.status=="P"));
        }
      }
      var _Items = this.menuPas.filter(x => (x.id == Id || x.parentId == Id) && x.status=="P");
      for (const _Item of _Items) {
        this.menuPasDeleted.push(_Item);
      }
      //drop item and its childrens
      this.menuPas = this.menuPas.filter(x =>!(( x.id == Id || x.parentId == Id) && x.status=="P"));
    }
    else {
      var _Item = this.menuPas.filter(x => x.id == Id && x.status=="R");
      if (_Item.length > 0) {
        if (_Item[0].parentId > 0) {
          var _Items = this.menuPas.filter(x => x.parentId == _Item[0].parentId && x.status=="R");
          if (_Items.length == 1) {
            this.menuPas = this.menuPas.filter(x =>!(x.id==_Item[0].parentId  && x.status=="R"));
          }
        }
        var _Items = this.menuPas.filter(x => (x.id == Id || x.parentId == Id) && x.status=="R");
        for (const _Item of _Items) {
          this.menuPasDeleted.push(_Item);
        }
        //drop item and its childrens
        this.menuPas = this.menuPas.filter(x => ! ((x.id == Id || x.parentId == Id) && x.status=="R"));
      }
    }
    return _Items;
  }


  b_OrderToProduction(PId, e: Event) {
    e.stopPropagation();
    this._IntervalProductionOn = false;
    let _Count = 0;
    var _Items = this.MoveScreenItemToProduction(PId);
    for (const _Item of _Items) {
      const _OP: IOrderId = {
        orderId: _Item.id, locationPrdId:this.locationId, sourceUpd:"ITK"
      }
      this.productionService.PutOrderinProduction(_OP).pipe(finalize(() => this.OTPFinish(_Items, PId, _Count)))
        .subscribe(result => {
          if (result.body.isValid) {
            this._IntervalProductionOn =true;

            _Count++;
          }
          else {
            if (result.body.resultCode != 409) {
              alert(result.body.error.description);
            }
          }
        },
          (e) => {
            console.log(e);
          });
    }
  }

  OTPFinish(PItems: any[], PId, PCount) {
    //if (PCount == PItems.length) {
    //this.loadPASInProduction();
    //}
  }


  b_OrderToIn(PId) {
    this._IntervalProductionOn = false;
    let _Count = 0;
    var _Items = this.MoveScreenItemToIn(PId);
    for (const _Item of _Items) {
      const _OP: IOrderId = {
        orderId: _Item.id, locationPrdId:this.locationId, sourceUpd:"ITK"

      }
      this.productionService.PutOrderIn(_OP).pipe(finalize(() => this.OTIFinish(_Items, PId, _Count)))
        .subscribe(result => {
          if (result.body.isValid) {
            this._IntervalProductionOn = true;

            _Count++;
          }
          else {
            if (result.body.resultCode != 409) {
              alert(result.body.error.description);
            }
          }
        },
          (e) => {
            console.log(e);
          });
    }
  }

  OTIFinish(PItems: any[], PId, PCount) {
    //if (PCount == PItems.length) {
    //this.loadPASInProduction();
    //}
  }


  b_OrderToOut(PId) {
    this._IntervalProductionOn = false;
    let _Count = 0;
    //var _Items = this.menuPasInProduction.filter(x => x.id == PId || x.parentId == PId);
    var _Items = this.MoveScreenItemToOut(PId);
    //this.menuPasInProduction = this.menuPasInProduction.filter(x => x.id != PId && x.parentId != PId)
    for (const _Item of _Items) {
      const _OP: IOrderId = {
        orderId: _Item.id, locationPrdId:this.locationId, sourceUpd:"ITK"
      }
      this.productionService.PutOrderOut(_OP).pipe(finalize(() => this.OTIFinish(_Items, PId, _Count)))
        .subscribe(result => {
          if (result.body.isValid) {
            this._IntervalProductionOn =true;

            _Count++;
          }
          else {
            if (result.body.resultCode != 409) {
              alert(result.body.error.description);
            }
          }
        },
          (e) => {
            console.log(e);
          });
    }
  }

  b_ProcessOrderInProduction(Pid, e: Event) {
    e.stopPropagation();
    if (this._ClickProductionModeNext) {
      this.b_OrderToOut(Pid);
    }
    else {
      this.b_OrderToIn(Pid);
      this.b_ClickProductionMode();
    }
  }

  b_ClickProductionMode() {
    this._ClickProductionModeNext = !this._ClickProductionModeNext;
    if (!this._ClickProductionModeNext) {
      this.openSB("Seleccione la orden a devolver.")
    }
  }

  ResetButtonPrdToIn() {
    this._ClickProductionModeNext = true;
    clearInterval(this._buttonPrdToInTimer);
  }

  b_back() {
    var _Route = this.routerService.getBackRoute();
    this.router.navigate([_Route], { skipLocationChange: true });
  //  this.router.navigate([this.routerService.routerParent]);
  }

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 5000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }
}






